import JButton from './JButton';

export default JButton;
